import { Grid, Box, Typography } from '@mui/material';
import { getSlideAttributesFromSlide } from 'components/PathologyMap/utilities/common';
import { usePathologyMapSlideCardContentStyles } from 'components/PathologyMap/PathologyMapSlideCards/styles';
import { SlideInfoTable } from 'components/PathologyMap/Modals/FullSlideInfoModal/SlideInfoSection/SlideInfoTable';
import { useState } from 'react';
import { useShouldDisplayArchivedSlides } from 'components/utilities/hooks/useShouldDisplayArchivedSlides';

export const PathologyMapSlideCardContent = ({
  slide,
  selectedFilters,
  handleOpenModal,
  isSlideCardViewed,
}) => {
  const [imageError, setImageError] = useState(false);
  const [showIsArchived, setShowIsArchived] = useState(false);
  const slideData = getSlideAttributesFromSlide({ slide });
  const { classes } = usePathologyMapSlideCardContentStyles();
  const shouldDisplayArchivedSlides = useShouldDisplayArchivedSlides(slide);

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <Grid
      container
      direction="row"
      spacing={0.5}
      className={classes.contentWrapper}
    >
      <Grid
        item
        xs={6}
        className={classes.imageWrapper}
        onClick={handleOpenModal}
        onMouseEnter={() =>
          !shouldDisplayArchivedSlides && setShowIsArchived(true)
        }
        onMouseLeave={() =>
          !shouldDisplayArchivedSlides && setShowIsArchived(false)
        }
      >
        {!imageError ? (
          <img
            src={slide.large_thumbnail_url}
            alt="Slide"
            width="100%"
            onError={handleImageError}
          />
        ) : (
          <Typography className={classes.placeholderText}>
            No Thumbnail Available
          </Typography>
        )}
        {showIsArchived && (
          <Box className={classes.overlayButton} disabled>
            Archived
          </Box>
        )}
        {isSlideCardViewed && (
          <Typography className={classes.overlayText}>Viewed</Typography>
        )}
      </Grid>
      <Grid item xs>
        <SlideInfoTable
          slide={slide}
          dataItems={slideData}
          selectedFilters={selectedFilters}
        />
      </Grid>
    </Grid>
  );
};
